<template>
  <div class="common-file-list my-2">
    <div @click.stop="() => {}">
      <vs-collapse>
        <vx-collapse-item icon-pack="feather" icon-arrow="icon-chevron-down">
          <div slot="header">
            <div
              class="flex items-center justify-between cursor-default p-2"
              @click.stop="() => {}"
            >
              <div class="flex items-center ml-2">
                <common-updated-label
                  :updatedAt="getDateTime(inputValue.updated_at)"
                  :createdAt="getDateTime(inputValue.created_at)"
                />
              </div>
            </div>
          </div>
          <vs-divider class="m-0"></vs-divider>
          <div class="upload-area p-2">
            <slot name="uploader"></slot>
          </div>
          <div v-for="(item, index) in files" :key="index">
            <common-file-list-item
              :file="item"
              :checked="item.checked"
              :ref="`ListItem${index}`"
              :deleteFile="deleteFile"
              :downloadFile="
                payload => onClickDownloadFile(payload.name, payload.token)
              "
              :onClickFileLink="
                payload => onClickFileLink(payload.name, payload.token)
              "
              :id="inputValue.id"
            ></common-file-list-item>
          </div>
        </vx-collapse-item>
      </vs-collapse>
    </div>
  </div>
</template>

<script>
import CommonFileListItem from "../molecules/CommonFileListItem.vue";
import VxCollapseItem from "./../../../../../../components/VxCollapseItem.vue";
import { ColorMixin, HullInsranceMixin } from "@/mixins";
import moment from "moment";
import CommonUpdatedLabel from "../../components/molecules/CommonUpdatedLabel.vue";

export default {
  components: { CommonFileListItem, VxCollapseItem, CommonUpdatedLabel },
  name: "O.CommonFileList",
  mixins: [ColorMixin, HullInsranceMixin],
  props: {
    title: { type: String, required: true },
    inputValue: {
      type: Object,
      required: true,
    },
    deleteFile: { type: Function },
    onClickDownloadFile: { type: Function },
    onClickFileLink: { type: Function },
  },
  data() {
    return {
      checked: false,
      files: [],
    };
  },
  watch: {
    inputValue: {
      handler: function() {
        this.setFiles();
      },
      deep: true,
    },
  },
  methods: {
    getDateTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    setFiles() {
      if (!this.inputValue.input_values) {
        this.files = [];
        return;
      }
      this.files = this.inputValue.input_values.map(item => {
        item.checked = false;
        return item;
      });
    },
  },

  created() {
    this.setFiles();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

.common-file-list {
  .vs-collapse {
    padding: 0;

    header {
      margin: 0 !important;
      padding: 0 !important;
    }

    .vs-collapse-item--header {
      // border-radius: 6px;
      padding: 0;
      margin: 0;
      font-size: 12px;
      font-family: $aisea-font-family;

      .vs-collapse-item--icon-header {
        display: flex;
        align-items: center;
        .vs-icon {
          width: 18px;
          color: $item-mono2;
        }
      }

      .list-expand {
        border-radius: 6px 6px 0 0;
        background: #f333;
      }
    }

    .vs-collapse-item {
      border: solid 1px $border-color1;
      border-bottom: solid 1px$border-color1 !important;
      border-radius: 6px;
      background-color: $aisea-pure-white;
    }
  }

  .con-content--item {
    margin: 0px !important;
    padding: 0px !important;
  }

  .icon-button {
    color: $item-mono2;
  }

  .unregistered-label {
    background-color: $aisea-red;
    font-weight: bold;
    color: $aisea-pure-white;
    border-radius: 4px;
    padding: 2px 8px;
    margin: 0 2px;
  }
}
</style>
